import { Pipe, PipeTransform} from '@angular/core';
import { Campaign } from "../_models/crmStats";
import { Report } from "../_models/report";


@Pipe({
  name: 'campaignpipe',
  pure: true
})
export class CampaignPipe implements PipeTransform {

  transform(items: Campaign[], filter: string): any {
    if (!items || !filter) {
      return items;
    }
    let multi = filter.split(' ');
    if (multi.length == 1) return items.filter(item => item.CampaignCode.toLowerCase().indexOf(filter.toLowerCase()) !== -1);
    else {
      let res: Campaign[] = items.filter(item => item.CampaignCode.toLowerCase().indexOf(multi[0].toLowerCase()) !== -1);
      for (let i = 1; i < multi.length; i++) {
        res = this.subfilter(res, multi[i]);
      }
      return res;
    }
  }
  subfilter(list:Campaign[],subfilter:string) {
    return list.filter(item => item.CampaignCode.toLowerCase().indexOf(subfilter.toLowerCase()) !== -1);
  }
}

@Pipe({
  name: 'repcam',
  pure: true
})
export class RepCampaignPipe implements PipeTransform {
  transform(items: Report[], filter: string): any {
    if (!items || !filter) {
      return items;
    }
    let multi = filter.split(' ');
    if (multi.length == 1) return items.filter(item => item.Campaign.toLowerCase().indexOf(filter.toLowerCase()) !== -1);
    else {
      let res: Report[] = items.filter(item => item.Campaign.toLowerCase().indexOf(multi[0].toLowerCase()) !== -1);
      for (let i = 1; i < multi.length; i++) {
        res = this.subfilter(res, multi[i]);
      }
      return res;
    }
  }
  subfilter(list: Report[], subfilter: string) {
    return list.filter(item => item.Campaign.toLowerCase().indexOf(subfilter.toLowerCase()) !== -1);
  }
}
@Pipe({
  name: 'repcamid',
  pure: true
})
export class RepCampaignIdPipe implements PipeTransform {
  transform(items: Report[], filter: string): any {
    if (!items || !filter) {
      return items;
    }
    let multi = filter.split(' ');
    if (multi.length == 1) return items.filter(item => item.CampaignId.toString().toLowerCase().indexOf(filter.toLowerCase()) !== -1);
    else {
      let res: Report[] = items.filter(item => item.CampaignId.toString().toLowerCase().indexOf(multi[0].toLowerCase()) !== -1);
      for (let i = 1; i < multi.length; i++) {
        res = this.subfilter(res, multi[i]);
      }
      return res;
    }
  }
  subfilter(list: Report[], subfilter: string) {
    return list.filter(item => item.CampaignId.toString().toLowerCase().indexOf(subfilter.toLowerCase()) !== -1);
  }
}
@Pipe({
  name: 'repcamdev',
  pure: true
})
export class RepCampaignDevPipe implements PipeTransform {
  transform(items: Report[], filter: string): any {
    if (!items || !filter || filter=="All") {
      return items;
    }
    return items.filter(item => item.Device == filter);
  }
}
@Pipe({
  name: 'repcamacc',
  pure: true
})
export class RepCampaignAccPipe implements PipeTransform {
  transform(items: Report[], filter: string): any {
    if (!items || !filter || filter == "All") {
      return items;
    }
    return items.filter(item => item.Account == filter);
  }
}
@Pipe({
  name: 'repcamjoin',
  pure: true
})
export class RepCampaignJoinPipe implements PipeTransform {
  transform(items: Report[], filter: string): any {
    if (!items || !filter || filter == "All") {
      return items;
    }
    return items.filter(item => item.JoinType == filter);
  }
}





// WEBPACK FOOTER //
// E:/Release/InzuzoA/InzuzoA/src/app/pipes/campaign.pipe.ts